<template>
  <b-container>
    <b-col lg="12" class="w-100">
    </b-col>
  </b-container>
</template>

<script>

export default {
  name: "SingleLesson",
}
</script>
